<template>
  <el-dialog title="Integration" :visible.sync="open" :append-to-body="true" @closed="$emit('close')">
    <div class="code">
      <pre><code>{{ code }}</code></pre>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="$emit('close')">Compris !</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'round-card',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      open: true
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('round', {
      getById: 'getById'
    }),

    round () {
      return this.getById(this.id)
    },

    code () {
      let html = " \n<div><!--You can write here if you want show something before the widget--></div>\n\n<div id='rf-round' data-id='" + this.id + "'></div>\n"
      if (this.site.sitekey === 'ppcommunautpmu' || this.site.sitekey === 'communautpmu') {
        html += `\n<script type='text/javascript'>\n//<![CDATA[\nsetTimeout((function(){RF.initWR()}), 1000)\n//]]>\n<\/script>`
      }

      html += '\n\n<div><!--You can write here if you want show something after the widget--></div>'
      return html
    }
  }
}
</script>

<style lang="scss" scoped>
  .round {
    padding: 18px;
    box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    .title {
      display: grid;
      min-height: 24px;
      align-items: center;
      grid-template-columns: 1fr 20px;
      h3 {
        margin: 0;

        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
      }
    }

    .description {
      p {
        margin: 4px 0 8px;
      }
    }

    &:hover {
      box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rounds/round-integration.vue